import { configureStore } from "@reduxjs/toolkit";
import basicInformationReducer from '../features/gms-proposal-forms/basic-information/basic-information.slice'
import gcToGEAMoPSlice from '../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice'
import typesProposalProductBasicPlanSliceReducer from '../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice'
import paymentTermLoanMaturityCommissionServicesNotesFilesSliceReducer from '../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice'
import ageBracketAndBenefitAmountSliceReducer from '../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice'
import levelRankingSliceReducer from '../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice'
import uniformCoverageSliceReducer from '../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice'
import salaryRankSliceReducer from '../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice'
import attachableRidersSliceReducer from '../features/gms-proposal-forms/attachable-rider/attachable-riders.slice'
import modalSliceReducer from '../features/gms-state-and-modal/modal-slice'
import stateSliceReducer from '../features/gms-state-and-modal/state-slice'
import amountOfLoansSliceReducer from '../features/gms-proposal-forms/amount-of-loans/amount-loans.slice'
import stepsChannelProposalAsSliceSliceReducer from '../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice'
import createAccountReducer from '../features/it-user-forms/user-forms-slice'
import annualPremiumEoiSliceReducer from '../features/actuarial/annual-premium-eoi.slice'
import documentSliceReducer from '../features/actuarial/document-slice'
import remarksSliceReducer from '../features/actuarial/remark-slice'
import fileRequirementSliceReducer from '../features/gms-proposal-forms/attachment/file-requirement.slice'
import requestAmendmentSliceReducer from '../features/actuarial/request-amendment/request-amendment.slice'
import policyDataPageSliceReducer from '../features/ebam/plicy-data-page/policy-data-page.slice'
import policyInformationSliceReducer from '../features/ebam/plicy-data-page/policy-information/policy-information.slice'
import policyCoveragePremiumDetailsSliceReducer from '../features/ebam/plicy-data-page/policy-coverage-premium-details/policy-coverage-premium-details.slice'
import policySpecialUnderwritingProvisionsSliceReducer from '../features/ebam/plicy-data-page/policy-special-underwriting-provisions/policy-special-underwriting-provisions.slice'
import ratesReducer from '../features/actuarial/rates-slice'
import policyTATSliceReducer from '../features/ebam/plicy-data-page/policy-tat/policy-tat.slice'
import paginationSliceReducer from '../features/pagination/pagination-slice'
import approvalSliceReducer from '../features/actuarial/approval/approval-slice'
import chatsSliceReducer from '../features/chats/chats-slice'
import authSliceReducer from '../features/auth/auth-slice'
import dashboardSliceReducer from '../features/dashboard/dashboard-slice'
import proposedDataSliceReducer from '../features/propose-data/propose-data-slice'
import conflictProposalSliceReducer from '../features/conflict-proposal/conflict-proposal-slice'
import transFerOwnershipSliceReducer from '../features/transfer-ownership/transfer-ownership-slice'
import myTeamSliceReducer from '../features/my-team/my-team-slice'
import { apiSlice } from "./api-slice";

// const isProd = process.env.REACT_APP_NODE_ENV === "production";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        authSlice: authSliceReducer,
        basicInformationSlice: basicInformationReducer,
        gcToGEAMoPSlice: gcToGEAMoPSlice,
        typesProposalProductBasicPlanSlice: typesProposalProductBasicPlanSliceReducer,
        paymentTermLoanMaturityCommissionServicesNotesFilesSlice: paymentTermLoanMaturityCommissionServicesNotesFilesSliceReducer,
        ageBracketAndBenefitAmountSlice: ageBracketAndBenefitAmountSliceReducer,
        levelRankingSlice: levelRankingSliceReducer,
        uniformCoverageSlice: uniformCoverageSliceReducer,
        salaryRankSlice: salaryRankSliceReducer,
        attachableRidersSlice: attachableRidersSliceReducer,
        modal: modalSliceReducer,
        state: stateSliceReducer,
        amountOfLoansSlice: amountOfLoansSliceReducer,
        createAccount: createAccountReducer,
        stepsChannelProposalAsSliceSlice: stepsChannelProposalAsSliceSliceReducer,
        fileRequirementSlice: fileRequirementSliceReducer,
        rates: ratesReducer,
        annualPremiumEoi: annualPremiumEoiSliceReducer,
        documentSlice: documentSliceReducer,
        remarksSlice: remarksSliceReducer,
        requestAmendmentSlice: requestAmendmentSliceReducer,

        policyDataPageSlice: policyDataPageSliceReducer,
        policyInformationSlice: policyInformationSliceReducer,
        policyCoveragePremiumDetailsSlice: policyCoveragePremiumDetailsSliceReducer,
        policySpecialUnderwritingProvisionsSlice: policySpecialUnderwritingProvisionsSliceReducer,
        policyTATSlice: policyTATSliceReducer,

        paginationSlice: paginationSliceReducer,
        approvalSlice: approvalSliceReducer,

        chatsSlice: chatsSliceReducer,
        proposedDataSlice: proposedDataSliceReducer,
        dashboardSlice: dashboardSliceReducer,

        conflictProposalSlice: conflictProposalSliceReducer,
        transFerOwnershipSlice: transFerOwnershipSliceReducer,
        myTeamSlice: myTeamSliceReducer,
        
    },
    middleware: getDefaultMiddleware => 
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "coverageType/setCsvFile",
                    "supportingDocument/addFiles",
                    "documentSlice/selectAddFilesDocument",
                    "api/executeMutation/fulfilled",
                    "chatsSlice/setChatValue",
                    "paymentTermLoanMaturityCommissionServicesNotesFilesSlice/files",
                    "paymentTermLoanMaturityCommissionServicesNotesFilesSlice/addFiles",
                ],
                ignoredPaths: [
                    'coverageType.csvFile',
                    'supportingDocument.files',
                    'documentSlice.filesDocument',
                    'chatsSlice.selectedFile',
                    'chatsSlice.setChatValue',
                    'paymentTermLoanMaturityCommissionServicesNotesFilesSlice.files',
                    'paymentTermLoanMaturityCommissionServicesNotesFilesSlice.addFiles',
                    "api.mutations",
                ],
            },
        }).concat(apiSlice.middleware),
    // devTools: !isProd
    devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch